module.exports = __webpack_public_path__ + "static/img/chat1.717e1ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/doubleDan/chat1.png
// module id = 9L71
// module chunks = 1